const allRoutes = {
  home: "/",
  sellProperty: "sell-property",
  properties: "properties",
  autoinvest: "autoinvest",
  user: "/user/",
  dashboard: "dashboard",
  login: "/login",
  signup: "/signup",
  forgotPassword: "/forgot-password",
  otp: "/otp",
  resetPassword: "/reset-password",
  // portal: "/portal/",
  portal: "/portal",
  cart: "/portal/cart",
  propertyDetail: "property-detail/",
  propertyPhotos: "property-detail/photos",
  contactIframe: "contact",
  portFolio: "/portal/portfolio",
  wallet: "wallet",
  cartPage: "cart",
  portfolio: "portfolio",
  profile: "profile",
  profileAccount: "profile/account",
  loginHistory: "/portal/login-history",
  changePassword: "/portal/change-password",
  clinicDetails: "/portal/clinic-details",
  myClinics: "/portal/my-clinics",
  downgradeChooser: "/portal/downgrade-plan",
  businessHours: "/portal/business-hours",
  appointmentSettings: "/portal/appointment-settings",
  taxSettings: "/portal/tax-settings",
  invoiceSettings: "/portal/invoice-settings",
  // Google Calendar & Meet — the backend's OAuth callback sends the browser back here.
  integrationSettings: "/portal/integration-settings",
  branding: "/portal/branding",
  preferences: "/portal/preferences",
  helpSupport: "/portal/help-support",
  bookmarked: "/portal/bookmark-properties",
  bankRequest: "/portal/bank-transfer-request",

  income: "/portal/income",
  addemployee: "/portal/addemployee",
  expense: "/portal/expense",
  addpatient: "/portal/addpatient",
  allpatient: "/portal/allpatient",
  guests: "/portal/guests",
  walletCredits: "/portal/wallet-credits",
  referrals: "/portal/referrals",
  patientprofile: "/portal/patientprofile",
  employeelist: "/portal/employeelist",
  loginAccess: "/portal/login-access",
  employeeprofile: "/portal/employeeprofile",
  settings: "/portal/settings",
  payment: "/portal/payment",
  paymentHistory: "/portal/paymentHistory",
  notifications: "/portal/notifications",
  invoice: "/portal/invoice",
  appointment: "/portal/appointment",
  appointmentFullscreen: "/portal/appointment/fullscreen",
  waitingList: "/portal/waiting-list",
  rolelist: "/portal/rolelist",
  addrole: "/portal/addrole",
  therapyIntelligence: "/portal/therapy-intelligence",
  // Predictive Intelligence (Phase 3)
  predictiveIntelligence: "/portal/predictive-intelligence",
  revenueForecast: "/portal/predictive-intelligence/revenue-forecast",
  dropoutRisk: "/portal/predictive-intelligence/dropout-risk",
  therapistPerformance: "/portal/predictive-intelligence/therapist-performance",
  businessAdvisor: "/portal/predictive-intelligence/business-advisor",
  dataHealth: "/portal/predictive-intelligence/data-health",
  planCheckout: "/portal/plan-checkout",
  services: "/portal/services",
  sessionTypes: "/portal/session-types",
  designations: "/portal/designations",
  // Group Sessions
  groupSessions: "/portal/group-sessions",

  // Payroll Management
  salaryManagement: "/portal/salary-management",
  deviceManager: "/portal/device-manager",

  // Leave Management
  leaveManagement: "/portal/leave-management",

  // Attendance Management
  attendanceManagement: "/portal/attendance",

  // Patient Billing (Phase 7)
  billingPricingPlans: "/portal/billing/pricing-plans",
  billingAttendance: "/portal/billing/attendance",
  billingSettlement: "/portal/billing/settlement",

  // Force Change Password (first login)
  forceChangePassword: "/force-change-password",

  // Clinic Chooser (multi-clinic owners)
  clinicChooser: "/choose-clinic",

  // Super Admin Panel
  superadmin: "/superadmin",
  superadminClinics: "/superadmin/clinics",
  superadminClinicDetails: "/superadmin/clinics/:clinicId",
  superadminSubscriptions: "/superadmin/subscriptions",
  superadminPlans: "/superadmin/plans",
  superadminRevenue: "/superadmin/revenue",
  superadminCrossBranch: "/superadmin/cross-branch",
  superadminActivityLogs: "/superadmin/activity-logs",
  superadminUsageStats: "/superadmin/usage-stats",
  superadminPaymentFailures: "/superadmin/payment-failures",
  superadminSupportTickets: "/superadmin/support-tickets",
  superadminTestimonials: "/superadmin/testimonials",
  superadminNewsletter: "/superadmin/newsletter",

  // Marketing / Public
  landing: "/",
  features: "/features",
  pricing: "/pricing",
  integrations: "/integrations",
  security: "/security",
  about: "/about",
  contact: "/contact",
  support: "/support",
  privacy: "/privacy",
  terms: "/terms",
};

export default allRoutes;
